import { CLINIC } from "@/lib/clinic";
import { MapPin, Clock, Phone, Navigation } from "lucide-react";

export default function Visit() {
  return (
    <section
      id="visit"
      data-testid="visit-section"
      className="py-20 sm:py-24 lg:py-32"
    >
      <div className="container mx-auto px-6 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-12">
          {/* Map */}
          <div className="lg:col-span-7">
            <div className="rounded-[2rem] overflow-hidden border border-stone-200 shadow-lg aspect-[4/3] bg-stone-100">
              <iframe
                title="Dent Square location map"
                data-testid="map-iframe"
                src={CLINIC.mapsEmbed}
                className="w-full h-full"
                style={{ border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
            </div>
          </div>

          {/* Details */}
          <div className="lg:col-span-5">
            <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.22em] text-[#3A564A]">
              <span className="h-px w-8 bg-[#3A564A]" />
              Visit us
            </span>
            <h2 className="font-display font-bold text-stone-900 text-4xl sm:text-5xl tracking-tight mt-5 leading-[1.05]">
              We're closer than you think.
            </h2>

            <div className="mt-8 space-y-5">
              <InfoRow icon={MapPin} title="Address" data-testid="info-address">
                {CLINIC.address}
              </InfoRow>
              <InfoRow icon={Phone} title="Phone" data-testid="info-phone">
                <a
                  href={`tel:${CLINIC.phoneTel}`}
                  className="hover:text-[#3A564A] transition-colors"
                >
                  {CLINIC.phoneDisplay}
                </a>
              </InfoRow>
              <InfoRow icon={Clock} title="Hours" data-testid="info-hours">
                <ul className="space-y-1">
                  {CLINIC.hoursDetailed.map((h) => (
                    <li
                      key={h.day}
                      className="flex justify-between text-sm gap-6"
                    >
                      <span className="text-stone-700">{h.day}</span>
                      <span className="text-stone-500">{h.time}</span>
                    </li>
                  ))}
                </ul>
              </InfoRow>
            </div>

            <div className="mt-8 flex flex-wrap gap-3">
              <a
                href={CLINIC.mapsLink}
                target="_blank"
                rel="noreferrer"
                data-testid="directions-btn"
                className="inline-flex items-center gap-2 px-6 py-3.5 rounded-full bg-[#3A564A] hover:bg-[#2C4239] text-[#FAFAF9] text-sm font-semibold transition-all hover:scale-[1.02]"
              >
                <Navigation className="w-4 h-4" /> Get Directions
              </a>
              <a
                href={`tel:${CLINIC.phoneTel}`}
                data-testid="visit-call-btn"
                className="inline-flex items-center gap-2 px-6 py-3.5 rounded-full bg-white border border-stone-300 text-stone-900 text-sm font-semibold hover:bg-stone-50"
              >
                <Phone className="w-4 h-4" /> {CLINIC.phoneDisplay}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function InfoRow({ icon: Icon, title, children, ...rest }) {
  return (
    <div className="flex gap-4" {...rest}>
      <div className="grid place-items-center w-11 h-11 rounded-2xl bg-[#3A564A]/10 text-[#3A564A] shrink-0">
        <Icon className="w-5 h-5" />
      </div>
      <div className="flex-1">
        <p className="text-xs font-bold uppercase tracking-[0.18em] text-stone-500 mb-1.5">
          {title}
        </p>
        <div className="text-stone-800 leading-relaxed">{children}</div>
      </div>
    </div>
  );
}
